<template>
  <div class="basic-search-form-wrap">
    <div class="basic-search-form-grid grey lighten-3">
      <SearchForm
        class="basic-search-content align-center pa-3"
        v-bind="$props"
      />
    </div>
  </div>
</template>

<script>
import SearchForm from "./SearchForm.vue";

export default {
  props: {
    business: {
      type: Number,
      required: true,
    },
  },
  components: {
    SearchForm,
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 960.001px) {
  .basic-search-form-wrap {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    justify-content: center;

    & .basic-search-form-grid {
      grid-column: 1 / -1 !important;
    }
  }
}

.basic-search-content::v-deep {
  display: grid;
  gap: 20px;

  &:not(.more-filters) {
    @media screen and (min-width: 1060.001px) {
      grid-template-columns: 300px auto;
    }
  }

  &.more-filters {
    grid-template-columns: repeat(6, 1fr);

    & > div {
      grid-column-end: span 2;
    }

    @media screen and (max-width: 1264px) {
      & > :nth-child(4),
      & > :nth-child(5),
      & > :nth-child(6) {
        grid-column-end: span 2;
      }

      & > :nth-child(7),
      & > :nth-child(8) {
        grid-column-end: span 3;
      }

      & > :nth-child(9) {
        grid-column-end: span 6;
      }
    }

    @media screen and (max-width: 1060px) {
      grid-template-columns: 1fr 1fr;

      & > :nth-child(1),
      & > :nth-child(2),
      & > :nth-child(3),
      & > :nth-child(4),
      & > :nth-child(7),
      & > :nth-child(8),
      & > :nth-child(9) {
        grid-column-end: span 2;
      }

      & > :nth-child(5),
      & > :nth-child(6) {
        grid-column-end: span 1;
      }
    }

    @media screen and (max-width: 500px) {
      & > :nth-child(5),
      & > :nth-child(6) {
        grid-column-end: span 2;
      }
    }
  }
}
</style>
